//#region src/locales/vi/settings.yaml
var data = {
	"common": { "save": "Lưu" },
	"animations": {
		"stage-transitions": { "title": "Tắt hiệu ứng chuyển cảnh" },
		"use-page-specific-transitions": {
			"description": "Một số trang sẽ có hiệu ứng chuyển cảnh riêng, điều này sẽ ghi đè hiệu ứng chuyển cảnh mặc định",
			"title": "Dùng hiệu ứng chuyển cảnh riêng cho từng trang"
		}
	},
	"dialogs": {
		"onboarding": {
			"official": { "title": "Nhà cung cấp chính thức của AIRI" },
			"title": "Chào mừng đến với AIRI!",
			"description": "Hãy thiết lập nhà cung cấp AI đầu tiên để bắt đầu.",
			"selectProvider": "Chọn nhà cung cấp AI",
			"configureProvider": "Cấu hình {provider}",
			"apiKey": "Khóa API",
			"apiKeyHelp": "Lấy khóa API từ {provider} và dán vào đây",
			"baseUrl": "URL gốc",
			"baseUrlHelp": "Địa chỉ API đầu cuối (dùng mặc định nếu không chắc)",
			"accountId": "ID tài khoản",
			"validationRunning": "Đang chạy các bài kiểm tra",
			"validationSuccess": "Xác thực cấu hình thành công",
			"validationPartial": "Cấu hình đã được xác thực một phần",
			"validationFailed": "Xác thực cấu hình thất bại",
			"validationError": "Lỗi xác thực: {error}",
			"testGenerationFailed": "Ping test thất bại",
			"retryPingCheck": "Thử lại",
			"skipForNow": "Bỏ qua",
			"saveAndContinue": "Lưu và tiếp tục",
			"next": "Tiếp",
			"retry": "Thử lại",
			"credentialsSafeLabel": "Hãy giữ các khóa API và thông tin xác thực an toàn!",
			"credentialsSafeLocal": "AIRI đang chạy hoàn toàn cục bộ trên PC của bạn và chúng tôi sẽ không bao giờ đánh cắp các thông tin xác thực cho các nhà cung cấp AI / LLM. Nhưng hãy nhớ rằng các khóa API của bạn là thông tin nhạy cảm. Hãy giữ chúng an toàn và không được chia sẽ với bất kỳ ai.",
			"credentialsSafeOpenSource": "AIRI là dự án mã nguồn mở trên {github}, nếu bạn muốn kiểm tra cách chúng tôi xử lý các thông tin xác thực của bạn, bạn có thể kiểm tra code của chúng tôi.",
			"enableChatCheck": "Cho phép AIRI gửi tín hiệu \"ping\" đến mô hình chat có thể dùng được đầu tiên để kiểm tra tính khả dụng",
			"start": "Bắt đầu thôi!",
			"loginPrompt": "Đăng nhập để sử dụng nhà cung cấp AIRI chính thức để có trải nghiệm tốt nhất.",
			"loginAction": "Đăng nhập",
			"setupWithoutSigningIn": "Thiết lập nhà cung cấp của bạn",
			"buyFlux": "Mua Flux",
			"select-model": "Chọn mô hình",
			"no-models": "Không có mô hình khả dụng",
			"no-models-help": "Vui lòng quay lại bước trước và kiểm tra khóa API, hoặc kiểm tra kết nối mạng.",
			"permissions": {
				"title": "Quản lý quyền",
				"description": "Bạn có thể cấp các quyền cần thiết ngay bây giờ hoặc tiếp tục và thiết lập sau.",
				"notificationsTitle": "Thông báo",
				"notificationsDescription": "Cho phép nhắc nhở và các cập nhật trạng thái quan trọng.",
				"microphoneTitle": "Micrô",
				"microphoneDescription": "Cho phép AIRI sử dụng micrô để nhập giọng nói và phiên âm.",
				"requestAction": "Yêu cầu quyền truy cập",
				"optionalHint": "Bạn vẫn có thể tiếp tục ngay cả khi chưa cấp các quyền này.",
				"stateGranted": "Đã cấp quyền",
				"stateNotGranted": "Không được cấp quyền"
			}
		},
		"bug-report": {
			"title": "Báo lỗi (´;ω;`)ヾ(･∀･`)",
			"subtitle": "Úi, xin lỗi nếu chúng tôi đã làm gì sai. Nếu không phiền thì bạn có thể kể cho chúng tôi biết chuyện gì đã xảy ra không?",
			"trigger-label": "Báo lỗi",
			"submit-label": "Gửi báo cáo lỗi",
			"triage-description": "Bao gồm ảnh chụp màn hình và nội dung trang để giúp chúng tôi phân loại sự cố này.",
			"description-placeholder": "Các bước để tái hiện, kết quả mong đợi và kết quả đã xảy ra",
			"include-current-page-screenshot": "Bao gồm ảnh chụp màn hình trang hiện tại",
			"manual-media": {
				"label": "Chọn các ảnh chụp màn hình / quay màn hình",
				"optional": "Tùy chọn."
			},
			"media-files": {
				"label": "Tệp đa phương tiện",
				"description": "Không bắt buộc: chọn thủ công.",
				"placeholder": "Chọn ảnh chụp màn hình hoặc tệp video",
				"selected-count": "{count} tệp đã được chọn"
			},
			"last-submitted-preview": "Xem Trước Payload Đã Gửi"
		}
	},
	"language": {
		"title": "Ngôn ngữ",
		"description": "Ngôn ngữ giao diện. Bạn có thể chỉnh ngôn ngữ nhân vật sau.\n"
	},
	"controls-island": { "icon-size": {
		"title": "Kích thước biểu tượng đảo",
		"description": "Điều chỉnh kích thước biểu tượng trên đảo điều khiển",
		"auto": "Tự động (thích ứng)",
		"large": "Lớn (mặc định)",
		"small": "Nhỏ"
	} },
	"analytics": {
		"notice": {
			"title": "Phân tích dữ liệu sử dụng",
			"description": "AIRI thu thập dữ liệu sử dụng một cách ẩn danh để giúp chúng tôi hiểu cách ứng dụng được dùng và cải thiện sự ổn định. Không có dữ liệu cá nhân nào được thu thập.",
			"privacyPrefix": "Đọc",
			"privacyLink": "chính sách quyền riêng tư",
			"onboardingHint": "Bạn có thể tắt phân tích ở Cài đặt > Hệ thống > Chung.",
			"settingsHint": "Bạn có thể tắt phân tích bất cứ lúc nào."
		},
		"toggle": {
			"title": "Bật phân tích dữ liệu sử dụng",
			"description": "Tắt để từ chối việc thu thập phân tích dữ liệu."
		},
		"disabled": { "title": "Phân tích dữ liệu bị vô hiệu hóa đối với bản dành cho nhà phát triển này" }
	},
	"model-select": {
		"panel-callout": {
			"support-status-header": "Chúng tôi hỗ trợ cả mô hình 2D và 3D",
			"support-status": "Nhấp vào {select-button} để chọn hoặc nhập các mô hình. Hiện tại, {zip} (cho Live2D và các Spine model), {vrm} (cho các VRM model) và {mmd} (cho các MMD model, được nén cùng texture) đều được hỗ trợ.\n",
			"model-type-example": "Neuro-sama sử dụng mô hình 2D được vận hành bởi framework được phát triển bởi Live2D Inc, trong khi đó Grok Ani (trong Grok Companion) sử dụng mô hình 3D được vận hành bởi VRM /MMD định dạng mở.\n"
		},
		"select-model": {
			"title": "Chọn Mô Hình",
			"button": "Chọn mô hình",
			"select": "Chọn",
			"import": "Nhập",
			"remove": "Xóa",
			"confirm": "Xác nhận"
		}
	},
	"live2d": {
		"change-model": {
			"from-file": "Tải từ tệp",
			"from-file-select": "Chọn",
			"from-url": "Tải từ URL",
			"from-url-confirm": "Tải",
			"from-url-placeholder": "Nhập URL mô hình Live2D",
			"title": "Đổi mô hình"
		},
		"edit-motion-map": { "title": "Chỉnh bản đồ chuyển động" },
		"map-motions": {
			"play": "Phát chuyển động",
			"title": "Gán chuyển động"
		},
		"title": "Cài đặt Live2D",
		"scale-and-position": {
			"title": "Tỉ lệ và vị trí",
			"scale": "Tỉ lệ"
		},
		"switch-to-vrm": {
			"title": "Chuyển sang mô hình 3D?",
			"change-to-vrm": "Bấm vào đây để đổi sang cài đặt mô hình 3D (VRM)"
		},
		"theme-color-from-model": {
			"title": "Trích xuất màu từ mô hình",
			"description": "Xuất các màu nổi bật từ canvas đang render hiện tại. Nhấp vào màu và áp dụng nó lên AIRI. Thử xuất nhiều lần với mô hình theo nhiều tư thế khác nhau nếu màu sắc chưa được như mong muốn.\n",
			"button-extract": { "title": "Trích xuất" }
		},
		"animation": {
			"title": "Hoạt ảnh",
			"focus": {
				"title": "Bật theo dõi chuột",
				"description": "Nhìn vào con trỏ chuột trong khi nó di chuyển. Chuyển động mắt khi rảnh (idle) sẽ tiếp tục khi con trỏ chuột dừng lại.",
				"offset": "Độ lệch mắt(%)"
			},
			"force-idle-eye-animation": {
				"title": "Chuyển động mắt nhàn rỗi (idle)",
				"description": "Nhìn xung quanh khi con trỏ chuột không di chuyển."
			},
			"blink-enable": {
				"title": "Mở chớp mắt",
				"description": "Cho phép mô hình chớp mắt."
			},
			"auto-blink": {
				"title": "Tự động",
				"description": "Sử dụng hoạt ảnh chớp mắt mặc định cho mô hình"
			},
			"force-auto-blink": {
				"title": "Ép buộc",
				"description": "Ép hoạt ảnh chớp mắt bằng bộ hẹn giờ ngoài"
			},
			"blink-mode": {
				"title": "Chế độ chớp mắt",
				"description": "Chọn mô hình chớp mắt có sẵn hoặc bộ hẹn giờ chớp mắt bắt buộc của AIRI."
			},
			"idle-motion": {
				"title": "Hoạt ảnh nhàn rỗi",
				"no-motion": "Không có hoạt ảnh khả dụng",
				"placeholder": "Chọn hoạt ảnh",
				"disable-motion": "Tắt",
				"disable-motion-description": "Tắt hoạt ảnh nhàn rỗi"
			}
		},
		"parameters": {
			"title": "Tham số mô hình",
			"render-scale": { "title": "Tỉ lệ render" },
			"fps": { "description": "Giới hạn tốc độ khung hình render" },
			"shadow": "Đổ bóng",
			"reset-parameters": "Đặt lại tham số mặc định"
		},
		"clear-model-cache": "Xóa bộ nhớ đệm của mô hình",
		"expressions": {
			"title": "Biểu cảm",
			"override-toggle": "Hệ thống biểu cảm",
			"sdk-preset-preserved-notice": "Quản lý biểu cảm SDK và nháy mắt được giữ nguyên khi tắt.\n",
			"no-expression": "Không có biểu cảm khả dụng cho mô hình này.",
			"llm-integration-wip": "Tích hợp công cụ LLM chưa được hoàn thiện.",
			"save-default": "Lưu biểu cảm mặc định",
			"reset": "Đặt lại tất cả biểu cảm",
			"expose-to-llm-toggle": "Cho phép LLM truy cập",
			"expose-to-llm-options": {
				"none": "Không",
				"all": "Tất cả",
				"custom": "Tùy chỉnh"
			}
		}
	},
	"microphone": "Micro",
	"models": "Mô hình",
	"pages": {
		"account": {
			"title": "Tài khoản",
			"description": "Xem hồ sơ của bạn và quản lý tài khoản",
			"notLoggedIn": "Đăng nhập để xem tài khoản và truy cập tất cả tính năng",
			"login": "Đăng nhập",
			"logout": "Đăng xuất",
			"fluxBalance": "Số dư Flux",
			"viewFluxDetails": "Xem chi tiết",
			"signedInAs": "Đăng nhập với",
			"profile": {
				"tab": "Hồ sơ",
				"title": "Hồ sơ",
				"description": "Quản lý tên hiển thị công khai.",
				"name": {
					"label": "Tên hiển thị",
					"placeholder": "Cách người khác thấy bạn"
				},
				"avatar": {
					"gravatarNotice": "Ảnh đại diện từ Gravatar.",
					"gravatarLink": "Quản lý trên gravatar.com"
				},
				"action": { "save": "Lưu thay đổi" },
				"message": { "saved": "Hồ sơ đã được cập nhật." },
				"error": { "fallback": "Chúng tôi không thể lưu các thay đổi của bạn." }
			},
			"connections": {
				"tab": "Các tài khoản đã được liên kết",
				"title": "Các tài khoản đã được liên kết",
				"description": "Đăng nhập AIRI thông qua các nhà cung cấp này. Hủy liên kết để thu hồi quyền truy cập, sau đó liên kết lại một lần nữa để chuyển sang tài khoản khác.",
				"status": {
					"linked": "Đã liên kết",
					"notLinked": "Chưa được liên kết",
					"linkedSince": "Đã liên kết vào {date}"
				},
				"action": {
					"link": "Liên kết",
					"unlink": "Hủy liên kết"
				},
				"message": {
					"loading": "Đang tải các tài khoản đã được liên kết...",
					"unlinked": "{provider} đã ngắt kết nối.",
					"linked": "{provider} đã kết nối.",
					"linkStarted": "Đang chuyển hướng đến {provider}…"
				},
				"error": {
					"listFailed": "Không thể tải các tài khoản đã liên kết.",
					"unlinkFailed": "Không thể hủy liên kết tài khoản này.",
					"linkFailed": "Không thể khởi động liên kết luồng (luồng liên kết).",
					"accountAlreadyLinkedToDifferentUser": "Tài khoản OAuth này đã được liên kết với một tài khoản AIRI khác. Hãy chọn tài khoản nhà cung cấp khác hoặc hủy liên kết tài khoản đó khỏi tài khoản AIRI kia trước.",
					"oauthCallbackFailed": "Không thể kết nối tài khoản OAuth này. Hãy thử lại hoặc chọn tài khoản nhà cung cấp khác.",
					"lastAccount": "Đây là phương thức đăng nhập duy nhất của bạn. Đặt mật khẩu trước khi hủy liên kết."
				}
			},
			"security": {
				"tab": "Bảo mật",
				"title": "Bảo mật",
				"description": "Thay đổi mật khẩu của bạn. Các thiết bị khác sẽ được đăng xuất.",
				"setDescription": "Bạn đăng nhập thông qua nhà cung cấp tài khoản mạng xã hội, vì vậy hiện tại chưa có mật khẩu. Chúng tôi sẽ gửi email liên kết bảo mật để giúp bạn đặt mật khẩu.",
				"currentPassword": {
					"label": "Mật khẩu hiện tại",
					"placeholder": "Nhập mật khẩu hiện tại"
				},
				"newPassword": {
					"label": "Mật khẩu mới",
					"placeholder": "Ít nhất 8 ký tự"
				},
				"confirmPassword": {
					"label": "Xác nhận mật khẩu mới",
					"placeholder": "Lặp lại mật khẩu mới"
				},
				"action": {
					"changePassword": "Thay đổi mật khẩu",
					"sendSetLink": "Gửi link thiết lập mật khẩu đến email của tôi"
				},
				"message": {
					"changed": "Mật khẩu đã được thay đổi. Các phiên khác đã được đăng xuất.",
					"setLinkSent": "Kiểm tra {email} để thấy link đặt mật khẩu."
				},
				"error": {
					"fallback": "Chúng tôi không thể thay đổi mật khẩu của bạn.",
					"setLinkFailed": "Chúng tôi không thể gửi link thiết lập mật khẩu.",
					"passwordMismatch": "Mật khẩu không khớp.",
					"passwordSameAsCurrent": "Mật khẩu mới phải khác mật khẩu cũ."
				}
			},
			"danger": {
				"tab": "Vùng Nguy Hiểm",
				"title": "Vùng Nguy Hiểm",
				"description": "Các hành động không thể đảo ngược cho tài khoản ở đây.",
				"deleteAccount": {
					"title": "Xóa tài khoản",
					"description": "Xóa tài khoản và dữ liệu cá nhân vĩnh viễn.",
					"action": "Xóa tài khoản",
					"modal": {
						"title": "Xóa tài khoản?",
						"warning": "Hành động này không thể đảo ngược. Các gói đăng ký đang hoạt động sẽ bị hủy, số dư Flux sẽ bị xóa sạch.",
						"confirmEmail": {
							"label": "Nhập email để xác nhận",
							"mismatch": "Email không khớp."
						},
						"confirm": "Gửi email xác nhận",
						"cancel": "Hủy"
					},
					"message": { "emailSent": "Kiểm tra {email} để thấy link xóa." },
					"error": { "fallback": "Không thể xóa. Hãy thử lại sau." }
				}
			}
		},
		"card": {
			"activate": "Kích hoạt",
			"active": "Đang hoạt động",
			"active_badge": "Hiện đang hoạt động",
			"activation_notice": "Đã chuyển sang {name}. Cuộc trò chuyện hiện tại giờ sử dụng nhân vật này.",
			"cancel": "Hủy thao tác",
			"save": "Lưu thay đổi",
			"save_and_activate": "Lưu và kích hoạt",
			"card_not_found": "Không tìm thấy thẻ",
			"character": "Nhân vật",
			"close": "Đóng",
			"chat": { "provider": "Trò chuyện / Nhà cung cấp" },
			"consciousness": { "model": "Ý thức / Mô hình" },
			"vision": {
				"provider": "Thị giác / Nhà cung cấp",
				"model": "Thị giác / Mô hình"
			},
			"created_by": "được tạo bởi",
			"creator_notes": "Ghi chú của tác giả",
			"delete": "Xóa",
			"delete_card": "Xóa thẻ",
			"delete_confirmation": "Bạn có chắc muốn xóa thẻ này?",
			"description": "Dùng preset thẻ nhân vật AIRI",
			"description_label": "Mô tả",
			"drop_here": "Kéo vào đây để tải lên",
			"create_card": "Tạo thẻ mới",
			"edit_card": "Chỉnh sửa thẻ",
			"creation": {
				"identity": "Danh tính",
				"name": "Tên",
				"nickname": "Biệt danh",
				"description": "Mô tả",
				"behavior": "Hành vi",
				"greetings": "Lời chào (mỗi dòng một lời chào)",
				"settings": "Cài đặt",
				"version": "Phiên bản",
				"create": "Tạo",
				"defaults": {
					"name": "Tên",
					"personality": "Bạn là một con người bình thường, tò mò về mọi thứ.",
					"scenario": "Bạn vừa tỉnh dậy và quên hết quá khứ.",
					"systemprompt": "Bạn sẽ nhận tin nhắn và trả lời như một con người thực sự.",
					"posthistoryinstructions": "Nhớ bắt chước như một con người."
				},
				"modules_info": "Cấu hình các module cho thẻ nhân vật này. Nếu không thiết lập, cấu hình mặc định sẽ được sử dụng.",
				"use_default": "Sử dụng mặc định",
				"use_default_not_configured": "Sử dụng mặc định (chưa cấu hình)",
				"fields_info": {
					"subtitle": "Bạn có thể thêm chi tiết về nhân vật, giải thích lịch sử, bối cảnh và cách nhân vật nên trả lời.",
					"name": "Tên chính thức của nhân vật.",
					"nickname": "Có thể đặt biệt danh để ưu tiên dùng.",
					"description": "Mô tả nhân vật này.",
					"notes": "Thêm ghi chú cá nhân nếu muốn.",
					"personality": "Miêu tả tính cách nhân vật. Nhút nhát? Tò mò? Hoặc khác?",
					"scenario": "Hoàn cảnh xung quanh? Tình huống hiện tại?",
					"greetings_field": "Lời chào",
					"greetings": "Nhân vật nên chào như thế nào?",
					"systemprompt": "Hướng dẫn AI LLM cách trả lời khi được hỏi.",
					"posthistoryinstructions": "Đặt thông tin mà AI LLM nên đọc sau lịch sử hội thoại.",
					"version": "Phiên bản thẻ, hãy tăng giá trị này nếu bạn đã chỉnh sửa thẻ từ trước.",
					"consciousness_model": "Chọn mô hình ý thức (mô hình AI) cho nhân vật này.",
					"speech_model": "Chọn mô hình tổng hợp tiếng nói và giọng đọc cho nhân vật này."
				},
				"errors": {
					"name": "Tên không hợp lệ hoặc rỗng.",
					"version": "Lỗi: Số phiên bản không hợp lệ!",
					"description": "Lỗi: Phải có mô tả cho thẻ này.",
					"personality": "Lỗi: Phải có tính cách cho nhân vật.",
					"scenario": "Lỗi: Phải có kịch bản.",
					"systemprompt": "Lỗi: Hãy cung cấp lời nhắc hệ thống",
					"posthistoryinstructions": "Lỗi: Cần có lịch sử đăng lời nhắc",
					"invalid_artistry_json": "Các tùy chọn cho nhà cung cấp nghệ thuật (Nghệ thuật provider) chứa JSON không hợp lệ."
				},
				"none": "Không"
			},
			"modules": "Mô-đun",
			"name_asc": "Tên (A-Z)",
			"name_desc": "Tên (Z-A)",
			"no_cards": "Chưa có thẻ nào. Bấm nút trên để tải lên!",
			"no_results": "Không tìm thấy thẻ phù hợp",
			"personality": "Tính cách",
			"posthistoryinstructions": "Hướng dẫn sau lịch sử",
			"recent": "Thêm gần đây",
			"scenario": "Kịch bản",
			"search": "Tìm thẻ...",
			"sort_by": "Sắp xếp theo",
			"body-model": "Cơ Thể / Mô Hình Hiển Thị",
			"speech": {
				"provider": "Giọng nói / Nhà cung cấp",
				"model": "Giọng nói / Mô hình",
				"voice": "Giọng nói / Giọng"
			},
			"systemprompt": "Lời nhắc hệ thống",
			"title": "Thẻ AIRI",
			"try_different_search": "Hãy thử từ khóa khác",
			"export": "Xuất",
			"exported": "Đã xuất gói thẻ",
			"export_failed": "Không thể xuất gói thẻ",
			"imported": "Đã nhập gói thẻ",
			"import_missing_file": "Gói thẻ thiếu các tệp bắt buộc",
			"import_invalid_file": "Tệp gói thẻ không hợp lệ",
			"upload": "Tải lên",
			"upload_desc": "Nhấp hoặc kéo thả gói thẻ AIRI vào đây để nhập"
		},
		"memory": {
			"description": "Nơi lưu trữ và tổ chức ký ức",
			"title": "Bộ nhớ"
		},
		"data": {
			"title": "Dữ liệu",
			"description": "Quản lý dữ liệu AIRI đã lưu, xuất và đặt lại",
			"sections": {
				"chats": {
					"title": "Phiên trò chuyện",
					"description": "Xuất hoặc nhập đoạn trò chuyện đã lưu.",
					"export": "Xuất hội thoại",
					"import": "Nhập hội thoại",
					"delete": "Xóa tất cả hội thoại"
				},
				"models": {
					"title": "Mô hình",
					"description": "Xóa các mô hình Live2D/VRM đã nhập.",
					"delete": "Xóa tất cả mô hình"
				},
				"modules": {
					"title": "Các Mô-Đun",
					"description": "Đặt lại tùy chọn mô-đun và thông tin xác thực.",
					"reset": "Đặt lại cài đặt mô-đun"
				},
				"providers": {
					"title": "Nhà cung cấp",
					"description": "Đã đặt lại toàn bộ thiết lập nhà cung cấp và thông tin xác thực.",
					"reset": "Đặt lại cài đặt nhà cung cấp"
				},
				"danger": {
					"title": "Cảnh báo",
					"description": "Các hành động không thể khôi phục. Hãy xuất những dữ liệu cần thiết trước khi tiếp tục."
				},
				"all": {
					"title": "Xóa tất cả dữ liệu",
					"description": "Xóa sạch toàn bộ thiết lập cục bộ, cấu hình nhà cung cấp và mô hình.",
					"delete": "Xóa sạch dữ liệu"
				},
				"desktop-folder": {
					"title": "Mở thư mục dữ liệu ứng dụng",
					"description": "Mở thư mục dữ liệu của AIRI trong trình quản lý tệp tin của bạn.",
					"open": "Mở thư mục"
				},
				"desktop": {
					"title": "Đặt lại thiết lập máy tính",
					"description": "Xóa các cài đặt và trạng thái thực thi của AIRI trên máy tính.",
					"center": "Đưa cửa sổ desktop về giữa màn hình",
					"reset": "Đặt lại dữ liệu desktop"
				}
			},
			"confirmations": {
				"tooltip": "Bạn chắc chứ?",
				"yes": "Đồng ý"
			},
			"status": {
				"exported": "Đã xuất phiên trò chuyện.",
				"imported": "Đã nhập phiên trò chuyện.",
				"import_error": "Lỗi nhập dữ liệu. Vui lòng kiểm tra định dạng tệp.",
				"chats_deleted": "Đã xóa các phiên trò chuyện.",
				"models_deleted": "Đã xóa các mô hình.",
				"modules_reset": "Đã đặt lại cài đặt mô-đun.",
				"providers_reset": "Đã đặt lại cài đặt nhà cung cấp.",
				"all_deleted": "Tất cả dữ liệu cục bộ đã bị xóa.",
				"desktop_window_centered": "Đã đưa cửa sổ desktop về giữa màn hình.",
				"desktop_reset": "Đã đặt lại dữ liệu ứng dụng máy tính."
			}
		},
		"models": {
			"description": "Live2D, VRM, Spine, v.v.",
			"title": "Mô hình",
			"sections": { "section": {
				"live2d": { "description": "Cấu hình mô hình Live2D" },
				"vrm": { "description": "Cấu hình mô hình 3D VRM" },
				"scene": "Bối cảnh"
			} }
		},
		"modules": {
			"beat_sync": {
				"description": "Rung cảm với nhịp điệu từ nguồn âm thanh",
				"title": "Đồng bộ nhịp",
				"sections": {
					"audio_source": {
						"actions": {
							"start_screen_capture": "Bắt đầu chụp màn hình",
							"stop": "Dừng"
						},
						"description": "Chọn nguồn âm thanh để nhận diện nhịp điệu.",
						"title": "Nguồn âm thanh"
					},
					"beat_visualizer": { "title": "Trình trực quan hóa nhịp" },
					"parameters": {
						"advanced_parameters": "Thông số nâng cao",
						"description": "Tinh chỉnh các thông số nhận diện nhịp điệu.",
						"title": "Thông số",
						"parameters": {
							"adaptive_threshold": {
								"description": "Áp dụng ngưỡng thích ứng dựa trên sự biến thiên tín hiệu theo thời gian.",
								"label": "Ngưỡng thích ứng"
							},
							"buffer_duration": {
								"description": "Thời gian của bộ đệm phân tích nội bộ.",
								"label": "Thời lượng bộ đệm"
							},
							"envelope_filter_frequency": {
								"description": "Tần số cho bộ lọc bao bì (envelope filter) để làm mượt các thay đổi năng lượng.",
								"label": "Tần số lọc bao bì"
							},
							"highpass_filter_frequency": {
								"description": "Tần số cho bộ lọc thông cao giúp giảm tần số thấp như tiếng ồn trầm.",
								"label": "Tần số lọc thông cao"
							},
							"lowpass_filter_frequency": {
								"description": "Tần số cho bộ lọc thông thấp giúp giảm tần số cao như giọng hát.",
								"label": "Tần số lọc thông thấp"
							},
							"min_beat_interval": {
								"description": "BPM tối đa hoặc khoảng thời gian tối thiểu giữa các nhịp được phát hiện.",
								"label": "BPM tối đa / Khoảng nhịp tối thiểu"
							},
							"sensitivity": { "label": "Độ nhạy" },
							"spectral_flux": {
								"description": "Bật phát hiện dựa trên thông lượng phổ (spectral flux).",
								"label": "Thông lượng phổ"
							},
							"warmup": {
								"description": "Làm nóng trước khi nhận diện để đạt độ chính xác cao hơn.",
								"label": "Khởi động (Warmup)"
							}
						}
					}
				}
			},
			"artistry": {
				"title": "Nghệ thuật",
				"description": "Tạo ảnh, cảnh nền và tranh ảnh.",
				"page": {
					"title": "Cấu Hình Nhà Cung Cấp Nghệ Thuật",
					"description": "Chọn nhà cung cấp backend đang hoạt động cho việc tạo ảnh. Các nhân vật có thể ghi đè trong cài đặt Thẻ của họ."
				},
				"providers": {
					"none": {
						"name": "Không",
						"description": "Bỏ qua và vô hiệu hóa module tạo ảnh trong phạm vi toàn cục."
					},
					"comfyui": {
						"name": "ComfyUI (Cục bộ)",
						"description": "Sử dụng bản ComfyUI cục bộ thông qua WSL cho việc tạo ảnh."
					},
					"replicate": {
						"name": "Replicate.ai (Đám mây)",
						"description": "Sử dụng các mô hình dựa trên đám mây thông qua API của Replicate."
					},
					"nanobanana": {
						"name": "Nano Banana (Bản xem trước)",
						"description": "Sử dụng Google AI Studio để xem trước ảnh và các phản ứng."
					}
				},
				"card": {
					"description": "Cấu hình cách AIRI tạo ảnh và các nội dung đồ họa.",
					"comfyui_empty": "ComfyUI workflows chưa được cấu hình. Đi tới Cài đặt → Nhà cung cấp → ComfyUI để tải mẫu workflow.",
					"exposed_fields": "{count} trường được cung cấp",
					"open_on_replicate": "Mở bằng Replicate",
					"instruction_sync": {
						"title": "Đồng bộ hướng dẫn ComfyUI",
						"description": "Prompt được chỉ định đã sẵn sàng cho workflow {workflowName} của bạn. Việc áp dụng sẽ ghi đè hướng dẫn tiện ích hiện tại nên AI sẽ biết cách dùng mẫu cụ thể này.",
						"apply": "Áp Dụng Prompt Được Khuyến Nghị",
						"keep": "Giữ nguyên"
					}
				},
				"provider": "Nhà Cung Cấp Nghệ Thuật",
				"spawn_mode": {
					"label": "Chế độ xuất hiện (Chế độ tạo)",
					"description": "Chọn cách ảnh được đưa vào giao diện.",
					"options": {
						"bg": "Nền Môi Trường",
						"inline": "Trò chuyện nội tuyến",
						"widget": "Widget lớp phủ",
						"bg_widget": "Kép (Ảnh Nền + Tiện Ích)"
					}
				},
				"autonomous": {
					"title": "Tự chủ điện ảnh (Họa sĩ tự động)",
					"description": "Khi bật, \"Producer\" sẽ chạy song song với nhân vật để quyết định xem có cần hình ảnh hay không. Điều này giúp nhân vật không quên tạo cảnh.",
					"threshold": "Ngưỡng xuất hiện",
					"threshold_description": "Dùng {min} để tạo cảnh mạnh tay hơn hoặc {max} để yêu cầu bằng chứng rõ ràng hơn trước khi tạo.",
					"threshold_min": "Luôn Luôn Tạo (0%)",
					"threshold_max": "Khắt Khe (100%)"
				},
				"model": {
					"label": "Mô Hình Nghệ Thuật (Ghi Đè Tùy Chọn)",
					"description": "Mã định danh mô hình nếu nhà cung cấp yêu cầu"
				},
				"prompt-prefix": {
					"label": "Tiền Tố Prompt Nghệ Thuật Mặc Định",
					"description": "Được thêm vào đầu mỗi prompt khi gửi đến trình tạo ảnh."
				},
				"options": { "label": "Tùy Chọn Nhà Cung Cấp Nghệ Thuật (JSON)" },
				"widget-instructions": {
					"label": "Prompt Tiện Ích Hệ Thống",
					"description": "Tùy chỉnh các hướng dẫn cho AI về cách dùng các khả năng tạo nội dung."
				}
			},
			"categories": {
				"essential": "Cần thiết",
				"messaging": "Nhắn tin",
				"gaming": "Chơi game",
				"artistry": "Nghệ thuật"
			},
			"consciousness": {
				"description": "Tính cách, mô hình mong muốn, v.v.",
				"sections": { "section": {
					"provider-model-selection": {
						"collapse": "Thu gọn",
						"custom_model_placeholder": "Nhập tên mô hình tùy chỉnh...",
						"current_model_label": "Mô hình hiện tại:",
						"description": "Chọn nhà cung cấp LLM phù hợp cho ý thức",
						"error": "Lỗi tải mô hình",
						"health_check_failed": "Kiểm tra trạng thái thất bại",
						"no_providers_configured_title": "Chưa cấu hình nhà cung cấp",
						"no_providers_configured_description": "Bấm vào đây để thiết lập nhà cung cấp LLM",
						"expand": "Mở rộng",
						"loading": "Đang tải mô hình...",
						"manual_model_name": "Tên mô hình",
						"manual_model_placeholder": "Nhập tên mô hình dùng với nhà cung cấp này",
						"no_models": "Không có mô hình",
						"no_models_description": "Không tìm thấy mô hình nào cho nhà cung cấp này",
						"no_search_results": "Không có kết quả phù hợp",
						"no_search_results_description": "Không có mô hình nào khớp với '{query}'. Thử từ khóa khác.",
						"not_supported": "Không hỗ trợ liệt kê mô hình",
						"not_supported_description": "Nhà cung cấp này không hỗ trợ chức năng liệt kê mô hình",
						"search_placeholder": "Tìm mô hình...",
						"search_results": "Tìm thấy {count}/{total} mô hình",
						"show_less": "Ẩn bớt",
						"show_more": "Hiện thêm",
						"subtitle": "Chọn một mô hình mặc định từ nhà cung cấp",
						"title": "Mô hình"
					},
					"model-options": {
						"title": "Tùy chọn mô hình",
						"thinking": { "label": "Suy nghĩ" }
					}
				} },
				"title": "Ý thức"
			},
			"description": "Tư duy, thị giác, tổng hợp giọng nói, chơi game, v.v.",
			"gaming-factorio": {
				"description": "Chơi Factorio!",
				"enable": "Bật tích hợp Factorio",
				"enable-description": "Cho phép AIRI tương tác với trò chơi Factorio",
				"server-address": "Địa chỉ máy chủ",
				"server-address-description": "Địa chỉ IP hoặc tên máy chủ của máy chủ Factorio",
				"server-address-placeholder": "Nhập địa chỉ máy chủ (ví dụ localhost hoặc 192.168.1.100)",
				"server-port": "Cổng máy chủ",
				"server-port-description": "Số cổng của máy chủ Factorio (mặc định 34197)",
				"username": "Tên người dùng",
				"username-description": "Tên người dùng của bạn trên máy chủ Factorio",
				"username-placeholder": "Nhập tên người dùng Factorio của bạn",
				"configured": "Đã cấu hình Factorio thành công!"
			},
			"gaming-minecraft": {
				"description": "Chơi Minecraft!",
				"enable": "Bật tích hợp Minecraft",
				"enable-description": "Bao gồm tự nhận thức về Minecraft trong lượt trò chuyện trên Sân khấu (Stage) và duy trì hiển thị thụ động trong thời gian chạy.",
				"configured": "Đã cấu hình Minecraft thành công!",
				"read-only": {
					"title": "Shell chỉ đọc",
					"description": "Sân khấu hiện tại hiển thị Minecraft dưới dạng shell thụ động. Trạng thái thời gian chạy và lưu lượng truy cập hiển thị tại đây, nhưng cấu hình dịch vụ vẫn nằm trong tệp dịch vụ Minecraft."
				},
				"setup": {
					"title": "Thiết lập",
					"description": "Bạn có thể tìm thấy các chỉ dẫn cho việc thiết lập bot trong file sau"
				},
				"runtime": {
					"title": "Thực thi được quan sát",
					"connection": "Kết nối",
					"latest-context": "Bối cảnh bot mới nhất",
					"waiting": "Đang chờ một lần đẩy ngữ cảnh mới từ bot.",
					"unknown": "Không xác định"
				},
				"debug": {
					"title": "Lưu lượng Minecraft",
					"empty": "Chưa ghi nhận lưu lượng Minecraft nào.",
					"source": "Nguồn: {source}"
				},
				"status": {
					"service-online": "Dịch vụ trực tuyến",
					"service-offline": "Dịch vụ ngoại tuyến",
					"no-runtime-context": "Chưa ghi nhận ngữ cảnh nào từ bot",
					"last-context-seconds": "Ngữ cảnh bot gần nhất: {seconds} giây trước",
					"last-context-stale": "Ngữ cảnh bot gần nhất: Đã cũ"
				}
			},
			"hearing": {
				"description": "Cấu hình nhận diện giọng nói",
				"title": "Nghe",
				"sections": { "section": {
					"provider-selection": { "description": "Chọn nhà cung cấp nhận diện giọng nói phù hợp" },
					"playground": {
						"current": "Phiên âm hiện tại",
						"description": "Lắng nghe qua pipeline Nghe đang hoạt động và hiển thị từng đoạn lời nói đã hoàn tất bên dưới.",
						"empty": "Bắt đầu theo dõi và nói vào micro đã chọn.",
						"error-title": "Lỗi phiên âm",
						"listening": "Đang lắng nghe giọng nói…",
						"no-transcription": "Không nhận diện được giọng nói trong đoạn âm thanh này.",
						"segment": "Đoạn lời nói {number}",
						"start": "Bắt đầu theo dõi",
						"stop": "Dừng theo dõi",
						"title": "Khu thử nghiệm nhận diện giọng nói",
						"transcribing": "Đang phiên âm…",
						"transcription-failed": "Phiên âm thất bại."
					},
					"confidence-threshold": {
						"title": "Ngưỡng Tự Tin",
						"description": "Lọc các đoạn nhận dạng giọng nói có độ tin cậy thấp để giảm tình trạng ảo tưởng của Whisper. Giá trị càng tiến về 0 thì càng khắt khe hơn; kéo sang trái để vô hiệu. Chỉ hiệu quả với các nhà cung cấp API của Whisper (ví dụ như OpenAI, Groq).",
						"disabled": "Tắt",
						"verbose-json-note": "Lưu ý: Nếu nhà cung cấp của bạn không hỗ trợ phản hồi verbose_json, cài đặt này sẽ không có tác dụng.",
						"verbose-json-unsupported": "Nhà cung cấp của bạn không trả về các đoạn (segment) verbose_json. Lọc kết quả dựa trên độ tin cậy không có tác dụng cho đoạn phiên âm mới nhất."
					}
				} }
			},
			"memory-long-term": {
				"description": "Cài đặt và quản lý trí nhớ dài hạn",
				"title": "Trí nhớ dài hạn"
			},
			"memory-short-term": {
				"description": "Cài đặt và quản lý trí nhớ ngắn hạn",
				"title": "Trí nhớ ngắn hạn"
			},
			"messaging-discord": {
				"description": "Trò chuyện & gọi thoại qua Discord",
				"enable": "Bật tích hợp Discord",
				"enable-description": "Cho phép AIRI tương tác qua Discord",
				"token": "Mã token của bot",
				"token-description": "Mã token bot Discord của bạn",
				"token-placeholder": "Nhập mã token bot Discord của bạn",
				"configured": "Đã cấu hình Discord thành công!"
			},
			"speech": {
				"description": "Tổng hợp giọng nói",
				"sections": { "section": {
					"playground": {
						"buttons": { "stop": { "label": "Dừng" } },
						"select-voice": {
							"loading": "Đang tải mô hình...",
							"required": "Vui lòng chọn một giọng nói"
						}
					},
					"voice-pack": {
						"description": "Chọn một giọng nói được tuyển chọn cho nhân vật đang hoạt động",
						"empty": "Không có Gói Giọng Nói khả dụng nào",
						"error": "Lỗi khi tải Gói Giọng Nói",
						"loading": "Đang tải Gói Giọng Nói...",
						"title": "Gói Giọng Nói"
					},
					"provider-voice-selection": {
						"custom_model_placeholder": "Nhập tên mô hình tùy chỉnh...",
						"custom_voice_placeholder": "Nhập ID giọng nói tùy chỉnh...",
						"description": "Chọn nhà cung cấp giọng nói phù hợp",
						"no_models": "Không có mô hình",
						"no_models_description": "Không tìm thấy mô hình nào cho nhà cung cấp này",
						"no_voices": "Không có giọng nói",
						"no_voices_description": "Không tìm thấy giọng nói nào cho nhà cung cấp này",
						"no_voices_hint": "Bạn có thể nhập tên giọng nói tùy chỉnh bên dưới.",
						"pause": "Tạm dừng",
						"play_sample": "Nghe thử",
						"search_models_placeholder": "Tìm mô hình...",
						"search_models_results": "Tìm thấy {count}/{total} mô hình",
						"search_voices_placeholder": "Tìm giọng nói...",
						"search_voices_results": "Tìm thấy {count}/{total} giọng nói",
						"unsupported_voice_warning_title": "Không có giọng nói được hỗ trợ",
						"unsupported_voice_warning_content": "Hãy thử nhà cung cấp hoặc mô hình khác. Chúng tôi đang nỗ lực cập nhật thêm giọng nói sớm nhất có thể. Nếu cần gấp, hãy báo cho chúng tôi trên GitHub.",
						"show_less": "Ẩn bớt",
						"show_more": "Hiện thêm",
						"title": "Nhà cung cấp"
					},
					"voice-settings": {
						"input-ssml": { "placeholder": "Nhập văn bản SSML..." },
						"use-ssml": {
							"description": "Bật để nhập SSML thô thay vì văn bản",
							"label": "Dùng SSML tùy chỉnh"
						}
					}
				} },
				"title": "Giọng nói"
			},
			"title": "Module",
			"vision": {
				"description": "Thị giác",
				"title": "Thị giác"
			},
			"x": {
				"description": "Sử Dụng Twitter",
				"enable": "Bật tích hợp X / Twitter",
				"enable-description": "Cho phép AIRI tương tác với X / Twitter",
				"api-key": "Khóa API",
				"api-key-description": "Khóa API X / Twitter của bạn",
				"api-key-placeholder": "Nhập khóa API X / Twitter của bạn",
				"api-secret": "Bí mật API",
				"api-secret-description": "Bí mật API X / Twitter của bạn",
				"api-secret-placeholder": "Nhập bí mật API X / Twitter của bạn",
				"access-token": "Mã truy cập",
				"access-token-description": "Mã truy cập X / Twitter của bạn",
				"access-token-placeholder": "Nhập mã truy cập X / Twitter của bạn",
				"access-token-secret": "Bí mật mã truy cập",
				"access-token-secret-description": "Bí mật mã truy cập X / Twitter của bạn",
				"access-token-secret-placeholder": "Nhập bí mật mã truy cập X / Twitter của bạn",
				"configured": "Đã cấu hình X / Twitter thành công!"
			},
			"web-search": {
				"title": "Tìm kiếm trên web",
				"description": "Cho phép AIRI tìm kiếm trên web để lấy thông tin mới nhất",
				"enable": "Kích hoạt Tìm kiếm trên Web",
				"enable-description": "Cho phép AIRI tìm kiếm trên web trong khi trò chuyện",
				"api-key": "Khóa API Tavily",
				"api-key-description": "Chức năng tìm kiếm trên web được cung cấp bởi Tavily. Nhận API miễn phí tại tavily.com.",
				"api-key-placeholder": "Nhập Tavily API của bạn",
				"configured": "Tìm kiếm web đã sẵn sàng sử dụng!"
			},
			"mcp-server": {
				"title": "Các máy chủ MCP",
				"description": "Cấu hình các máy chủ MCP và đưa công cụ của chúng vào AIRI.",
				"config-path": "Tệp cấu hình",
				"runtime-title": "Trạng thái thực thi",
				"empty": "Chưa có máy chủ MCP nào. Nhấp \"Thêm máy chủ\" bên dưới để tạo một máy chủ, hoặc dán cấu hình qua \"Chỉnh sửa JSON\".",
				"error-title": "Úi",
				"success-title": "Xong!",
				"existing": {
					"title": "Đã cấu hình",
					"description": "Các máy chủ được lưu trong mcp.json. Nhấp vào một dòng để mở rộng và chỉnh sửa.",
					"empty": "Chưa có cái nào ở đây hết. Thêm một cái vào bên dưới đi!"
				},
				"add": {
					"title": "Mới",
					"description": "Điền thông tin máy chủ mới, sau đó nhấp \"Lưu và khởi động lại\". Máy chủ sẽ được chuyển lên mục \"Đã cấu hình\" ở trên.",
					"pending-badge": "Chưa được lưu"
				},
				"status": { "unknown": "chưa tải" },
				"actions": {
					"open-config": "Hiển thị trong trình quản lý tệp",
					"apply-and-restart": "Lưu và khởi động lại",
					"restart": "Khởi động lại MCP",
					"add-server": "Thêm máy chủ",
					"add-env": "Thêm biến",
					"remove": "Xóa",
					"test": "Kiểm tra",
					"edit-json": "Chỉnh sửa JSON",
					"close-json": "Đóng",
					"format-json": "Định dạng",
					"reset-draft": "Khởi động lại",
					"apply-json": "Áp dụng",
					"cancel": "Hủy",
					"expand": "Mở rộng",
					"collapse": "Thu gọn"
				},
				"fields": {
					"identifier": {
						"label": "Mã định danh",
						"description": "Tên độc nhất; trở thành khóa trong mcp.json.",
						"placeholder": "ví dụ: filesystem"
					},
					"command": {
						"label": "Lệnh",
						"description": "Tệp thực thi được khởi chạy qua stdio.",
						"placeholder": "ví dụ: npx"
					},
					"args": {
						"label": "Đối số",
						"description": "Mỗi dòng một đối số, theo thứ tự."
					},
					"cwd": {
						"label": "Thư mục làm việc",
						"description": "Thư mục tùy chọn được dùng làm thư mục làm việc của tiến trình.",
						"placeholder": "ví dụ: /Users/you/project"
					},
					"env": {
						"label": "Môi trường",
						"description": "Các biến được đưa vào tiến trình con.",
						"key-placeholder": "KHÓA",
						"value-placeholder": "giá trị"
					},
					"enabled": { "label": "Bật" }
				},
				"json": {
					"title": "Chỉnh sửa mcp.json",
					"description": "Chỉnh sửa trực tiếp JSON thô. Nhấp \"Áp dụng\" để nạp vào biểu mẫu, sau đó \"Lưu và khởi động lại\" để ghi vào đĩa.",
					"placeholder": "Dán mcp.json vào đây…"
				},
				"test": {
					"title": "Kiểm tra kết nối",
					"description": "Máy chủ sẽ được khởi chạy trong thời gian ngắn để kiểm tra lệnh có hoạt động và xem máy chủ cung cấp những công cụ nào.",
					"pick-server-label": "Máy chủ",
					"no-servers": "Chưa có gì để kiểm tra",
					"no-server-selected": "Chọn một máy chủ trước.",
					"server-disabled": "\"{name}\" đã bị vô hiệu hóa — hãy bật nó trên thẻ trước.",
					"disabled-suffix": "đã vô hiệu hóa",
					"untitled": "chưa có tiêu đề",
					"running": "Đang kiểm tra…",
					"success": "Kết nối thành công! Đã tìm thấy {count} công cụ trong {ms}ms.",
					"failure": "Kết nối thất bại sau {ms}ms"
				},
				"errors": {
					"empty-identifier": "Máy chủ",
					"duplicate-identifier": "Mã định danh \"{name}\" đã được sử dụng nhiều hơn một lần — tên phải là duy nhất.",
					"empty-command": "\"{name}\" đang thiếu một lệnh.",
					"invalid-shape": "Nhìn không giống mcp.json hợp lệ — gốc (root) cần một trường \"mcpServers\"."
				},
				"messages": {
					"opened": "Đã mở {path} trong trình quản lý tệp của bạn",
					"json-applied": "Đã áp dụng JSON vào biểu mẫu. Nhấp \"Lưu và khởi động lại\" để lưu vào đĩa.",
					"restarted": "Tất cả đã được khởi động lại! {started} đã khởi động, {failed} thất bại, {skipped} đã bỏ qua."
				}
			}
		},
		"flux": {
			"buy": "Mua",
			"currency": "Tiền tệ",
			"description": "Số Flux hiện tại",
			"packagesError": "Không thể tải các gói. Vui lòng thử lại sau.",
			"checkout": {
				"success": "Thanh toán hoàn tất! Flux của bạn đã được nạp.",
				"canceled": "Thanh toán đã bị hủy.",
				"error": "Đã xảy ra sự cố. Xin vui lòng thử lại sau."
			},
			"audit": {
				"title": "Lịch Sử Giao Dịch",
				"time": "Thời gian",
				"type": "Loại",
				"detail": "Chi tiết",
				"amount": "Số lượng",
				"typeAddition": "Nạp thêm",
				"typeConsumption": "Mức sử dụng",
				"typeInitial": "Khoản Cấp Ban Đầu",
				"typePromo": "Tặng khuyến mãi",
				"loading": "Đang tải lịch sử...",
				"empty": "Chưa có giao dịch nào.",
				"loadMore": "Tải Thêm",
				"delayHint": "Các bản ghi về mức sử dụng có thể bị trễ 1 phút",
				"ttsRequests": "các yêu cầu"
			},
			"packages": {
				"title": "Gói Flux",
				"buy": "Mua",
				"description": "Các gói Flux để lựa chọn."
			}
		},
		"providers": {
			"catalog": { "edit": {
				"config-id-not-found": "Không tìm thấy cấu hình nhà cung cấp.",
				"definition-id-not-found": "Không tìm thấy định nghĩa nhà cung cấp.",
				"actions": {
					"more-options": "Thêm tùy chọn",
					"delete": "Xóa"
				},
				"validation": { "failed": {
					"title": "Xác thực không thành công. Vui lòng kiểm tra lại cài đặt.",
					"description": "Bạn vẫn có thể lưu cấu hình nếu muốn tiếp tục.",
					"action": "Vẫn lưu"
				} },
				"config": {
					"loading": "Đang tải cài đặt nhà cung cấp...",
					"load-error": "Không thể tải cài đặt nhà cung cấp.",
					"save-error": "Không thể lưu cài đặt nhà cung cấp.",
					"retry": "Thử lại",
					"common": { "fields": { "field": {
						"api-key": {
							"label": "Khóa API",
							"description": "Khóa dùng để ủy quyền yêu cầu cho nhà cung cấp này"
						},
						"base-url": {
							"label": "URL cơ sở",
							"description": "Địa chỉ kết nối dịch vụ. Thường là http: \"//localhost:11434/v1 hoặc tương tự.\"",
							"placeholder": "URL cơ sở..."
						},
						"download-model": {
							"label": "Tải xuống mô hình",
							"description": "Tải xuống mô hình Chromium Prompt API"
						},
						"headers": {
							"label": "Tiêu đề HTTP tùy chỉnh",
							"description": "Tùy chỉnh Tiêu đề HTTP",
							"key": { "placeholder": "Khóa (Key)" },
							"value": { "placeholder": "Giá trị (Value)" }
						},
						"thinking-mode": {
							"label": "Chế độ suy nghĩ",
							"description": "Kiểm soát hành vi suy nghĩ của Ollama/GPT-OSS.\n",
							"options": {
								"auto": "Tự động",
								"disable": "Tắt",
								"enable": "Bật",
								"low": "Thấp",
								"medium": "Trung bình",
								"high": "Cao"
							}
						}
					} } }
				},
				"validators": {
					"actions": { "validate": "Xác thực" },
					"empty": "Không có bước xác thực khả dụng.",
					"openai-compatible": {
						"check-config": { "title": "Cấu hình" },
						"check-connectivity": { "title": "Kết nối" },
						"check-supports-model-listing": { "title": "Liệt kê mô hình" },
						"check-supports-chat-completion": { "title": "Hoàn tất hội thoại" }
					},
					"prompt-api": { "check-availability": { "title": "tính khả dụng" } },
					"status": {
						"validating": "Đang xác thực...",
						"valid": "Thành công",
						"invalid": "Lỗi"
					},
					"title": "Kiểm tra"
				},
				"providers": { "provider": { "ollama": { "troubleshooting": { "validators": { "openai-compatible-check-connectivity": {
					"label": "Cần cấu hình thêm cho Ollama",
					"content": "Kiểm tra kết nối thất bại. Đối với Ollama, bạn cần đặt biến môi trường <code>OLLAMA_HOST</code> khi khởi động để cho phép kết nối. Xem hướng dẫn tại trang tài liệu."
				} } } } } }
			} },
			"common": {
				"continueAnyway": "Vẫn tiếp tục",
				"goToModelSelection": "Chọn Mô hình →",
				"fields": { "field": { "api-key": { "label": "Nhập khóa API" } } },
				"section": {
					"advanced": {
						"fields": { "field": { "headers": {
							"description": "Thêm HTTP header tùy chỉnh",
							"key": { "placeholder": "Khóa" },
							"label": "Tiêu đề HTTP",
							"value": { "placeholder": "Giá trị" }
						} } },
						"title": "Nâng cao"
					},
					"basic": {
						"description": "Cài đặt cơ bản",
						"title": "Cơ bản"
					},
					"voice": { "title": "Cài đặt giọng nói" }
				}
			},
			"labels": { "recommended": "Được gợi ý" },
			"filters": {
				"pricing": "Bảng Giá",
				"deployment": "Triển khai",
				"all": "Tất cả",
				"free": "Miễn phí",
				"paid": "Trả phí",
				"internal": "Nội bộ",
				"local": "Cục bộ",
				"cloud": "Đám mây"
			},
			"categories": {
				"chat": {
					"title": "Trò chuyện",
					"description": "Nhà cung cấp mô hình tạo văn bản. Ví dụ: OpenRouter, OpenAI, Ollama."
				},
				"vision": {
					"title": "Thị giác",
					"description": "Các nhà cung cấp mô hình thị giác máy cho việc hiểu hình ảnh."
				},
				"speech": {
					"title": "Giọng nói",
					"description": "Các nhà cung cấp mô hình giọng nói (text-to-speech). Ví dụ: ElevenLabs, Azure Giọng nói."
				},
				"transcription": {
					"title": "Phiên âm",
					"description": "Các nhà cung cấp mô hình phiên âm (speech-to-text). Ví dụ: Whisper.cpp OpenAI, Azure Giọng nói"
				},
				"artistry": {
					"title": "Nghệ thuật",
					"description": "Các nhà cung cấp mô hình tạo ảnh và thiết kế. Ví dụ: ComfyUI, Replicate.",
					"items": {
						"comfyui": { "description": "Chương trình tạo ảnh cục bộ." },
						"replicate": { "description": "Dịch vụ mô hình suy luận dựa trên đám mây." },
						"nanobanana": { "description": "Xem trước hình ảnh trên Google AI Studio." }
					}
				}
			},
			"helpinfo": {
				"title": "Lần đầu tới đây?",
				"description": "{chat} AIRI cần ít nhất một nhà cung cấp để suy nghĩ và hoạt động đúng cách. Có thể coi nó như bộ não của nhân vật AIRI trong hệ thống.\n"
			},
			"explained": {
				"chat": "Nhà cung cấp mô hình tạo văn bản. Ví dụ: OpenRouter, OpenAI, Ollama.",
				"Speech": "Nhà cung cấp mô hình giọng nói (text-to-speech). Ví dụ: ElevenLabs, Azure Speech.",
				"Transcription": "Nhà cung cấp mô hình chuyển giọng nói thành văn bản. Ví dụ: Whisper.cpp, OpenAI, Azure Speech"
			},
			"description": "LLMs, nhà cung cấp giọng nói, v.v.",
			"provider": {
				"apple-speech-transcription": {
					"title": "Apple Giọng nói",
					"description": "Nhận diện giọng nói trên thiết bị với macOS 26 trở lên. Không yêu cầu khóa API.",
					"fields": { "locale": {
						"label": "Ngôn ngữ địa phương",
						"description": "Sử dụng locale Apple Giọng nói chính xác, chẳng hạn en-US hoặc zh-CN."
					} }
				},
				"app-local-audio-transcription": { "title": "Ứng dụng (Local)" },
				"app-local-audio-speech": { "title": "Ứng dụng (Local)" },
				"browser-local-audio-transcription": { "title": "Trình duyệt (Local)" },
				"browser-local-audio-speech": { "title": "Trình duyệt (Local)" },
				"alibaba-cloud-model-studio": { "title": "Mô hình Studio Alibaba Cloud" },
				"amazon-bedrock": { "config": {
					"api-key": {
						"label": "Khóa API Bedrock",
						"description": "Khóa API Amazon Bedrock (tạo trong AWS Console → Bedrock → API Keys)"
					},
					"region": {
						"label": "Khu vực AWS",
						"description": "Khu vực AWS nơi Bedrock được bật (ví dụ: us-east-1, us-west-2)"
					}
				} },
				"anthropic": { "helpinfo": {
					"title": "Trước khi bắt đầu",
					"description": {
						"part1": "Anthropic gần đây công bố hỗ trợ beta cho SDK OpenAI",
						"part2": "(xem thêm tại đây)",
						"part3": "nhưng do chi tiết triển khai đi kèm",
						"part4": "với hạn chế không tương thích hoàn toàn với SDK OpenAI, hiện chưa thể dùng nhà cung cấp này trong trình duyệt.",
						"part5": "Nếu cần dùng, bạn phải có proxy backend riêng như Serverless Function",
						"part6": "hoặc dịch vụ bypass CORS để vượt hạn chế."
					}
				} },
				"cloudflare-workers-ai": { "fields": { "field": {
					"account-id": {
						"description": "ID tài khoản Cloudflare",
						"label": "ID Tài khoản",
						"placeholder": "ID tài khoản Cloudflare của bạn"
					},
					"api-key": { "placeholder": "Nhập khóa API cho Cloudflare" }
				} } },
				"common": {
					"status": {
						"validating": "Đang xác thực",
						"valid": "Cấu hình có vẻ hợp lệ."
					},
					"fields": { "field": {
						"pitch": {
							"description": "Điều chỉnh cao độ giọng nói",
							"label": "Cao độ"
						},
						"speed": {
							"description": "Điều chỉnh tốc độ giọng nói",
							"label": "Tốc độ"
						},
						"volume": {
							"description": "Điều chỉnh âm lượng",
							"label": "Âm lượng"
						}
					} }
				},
				"speech-noop": {
					"title": "Không có",
					"description": "Không phát âm thanh."
				},
				"comfyui": { "settings": {
					"title": "ComfyUI (Cục bộ)",
					"heading": "API gốc ComfyUI",
					"description": "Kết nối với ComfyUI cục bộ và sử dụng các workflow của bạn.",
					"info": {
						"what_you_need": {
							"label": "Những Gì Bạn Cần",
							"value": "ComfyUI đang chạy cục bộ hoặc trên mạng của bạn."
						},
						"how_to_export": {
							"label": "Cách Để Xuất",
							"value": "Bật Chế Độ Nhà Phát Triển → \"Lưu (Định Dạng API)\"."
						},
						"scope_boundary": {
							"label": "Giới Hạn Phạm Vi",
							"value": "Bạn tự chịu trách nhiệm tải mô hình và cài đặt node."
						}
					},
					"connection": {
						"title": "Kết nối",
						"connected": "Đã kết nối",
						"failed": "Kết nối thất bại",
						"error_prefix": "Lỗi",
						"test": "Kiểm tra",
						"testing": "Đang kiểm tra...",
						"unknown_error": "Lỗi kết nối không xác định",
						"unknown_gpu": "GPU không xác định",
						"server_url": {
							"label": "URL máy chủ",
							"description": "Địa chỉ ComfyUI đang hoạt động"
						}
					},
					"cors": {
						"title": "Yêu Cầu Bị Chặn Bởi CORS",
						"description": "ComfyUI mặc định chặn các yêu cầu từ các ứng dụng khác. Để cho phép AIRI kết nối, bạn phải bắt đầu ComfyUI với flag `--enable-cors-header \"*\"`."
					},
					"workflows": {
						"title": "Mẫu Workflow",
						"upload": "Tải Workflow",
						"cancel_upload": "Hủy",
						"empty": "Chưa có workflow nào được tải lên. Nhấp \"Tải workflow\" để nhập workflow_api.json từ ComfyUI.",
						"exposed_parameters": "Tham số được cung cấp",
						"summary": "{nodes} node · {fields} trường được cung cấp",
						"remove": "Xóa",
						"config_snippet": "Đoạn cấu hình Nghệ thuật",
						"copy_json": "Sao chép JSON",
						"paste_hint": "Dán nội dung này vào cấu hình Nghệ thuật của Thẻ AIRI để ghi đè các node này."
					},
					"upload": {
						"prompt": "Kéo thả hoặc chọn tệp workflow_api.json",
						"invalid_json": "JSON không hợp lệ",
						"workflow_name": {
							"label": "Tên Workflow",
							"description": "Cho workflow này một cái tên dễ nhận biết nào",
							"placeholder": "ví dụ: Anime Text2Img"
						},
						"select_fields": "Chọn các trường muốn cung cấp cho tác nhân AI:",
						"fields_exposed": "{count} trường được cung cấp",
						"save": "Lưu Workflow"
					}
				} },
				"replicate": { "settings": {
					"heading": "Cấu Hình Replicate.ai",
					"description": "Cấu hình cài đặt trình tạo ảnh của bạn.",
					"api_key": {
						"label": "Khóa API",
						"description": "Token Replicate API của bạn (bắt đầu với r8_)"
					},
					"default_model": {
						"label": "Mô Hình Mặc Định",
						"description": "Chuỗi owner/model dự phòng được dùng nếu thẻ nhân vật không chỉ định."
					},
					"aspect_ratio": {
						"label": "Tỉ Lệ Khung Hình",
						"description": "Tỉ lệ ảnh mặc định (ví dụ: 16:9 1:1 9:16)"
					},
					"inference_steps": {
						"label": "Các Bước Suy Luận",
						"description": "Số lượng bước cho quá trình khử nhiễu (giá trị thấp thì nhanh hơn, giá trị cao thì chất lượng tốt hơn)"
					}
				} },
				"nanobanana": { "settings": {
					"heading": "Nano Banana (Google AIスタジオ)",
					"description": "Cấu hình khả năng tạo ảnh gốc của Google Gemini.",
					"api_key": {
						"label": "Khóa API",
						"description": "Khóa Google AI Studio API của bạn"
					},
					"preferred_model": {
						"label": "Mô hình ưu tiên",
						"description": "Mô hình xem trước tạo ảnh Gemini cụ thể sẽ được sử dụng"
					},
					"default_resolution": {
						"label": "Độ Phân Giải Mặc Định",
						"description": "Độ phân giải mong muốn cho ảnh được tạo"
					},
					"model_options": {
						"nano_banana_2": "Nano Banana 2（Gemini 3.1 Flash Image）",
						"nano_banana_pro": "Nano Banana Pro（Gemini 3 Pro Image）",
						"nano_banana": "Nano Banana（Gemini 2.5 Flash Image）"
					}
				} },
				"deepseek": { "fields": { "field": { "thinking-mode": { "description": "Kiểm soát việc các mô hình suy luận DeepSeek có sử dụng chế độ suy nghĩ trong yêu cầu trò chuyện hay không." } } } },
				"elevenlabs": {
					"fields": { "field": {
						"simularity-boost": {
							"description": "Bám sát giọng gốc",
							"label": "Tăng độ tương đồng"
						},
						"speaker-boost": {
							"description": "Giọng nói tự nhiên hơn",
							"label": "Tăng độ chân thực"
						},
						"speed": {
							"description": "Tốc độ giọng nói",
							"label": "Tốc độ"
						},
						"stability": {
							"description": "Độ ổn định và ngẫu nhiên",
							"label": "Ổn định"
						},
						"style": {
							"description": "Cường điệu phong cách giọng",
							"label": "Phong cách"
						}
					} },
					"playground": {
						"buttons": { "button": { "test-voice": {
							"generating": "Đang tạo...",
							"label": "Thử giọng"
						} } },
						"fields": { "field": {
							"input": { "placeholder": "Nhập văn bản để thử giọng..." },
							"language": {
								"description": "Chọn ngôn ngữ",
								"label": "Ngôn ngữ"
							},
							"voice": {
								"description": "Chọn giọng nói ưa thích",
								"label": "Giọng"
							}
						} },
						"title": "Thử nghiệm giọng nói",
						"validation": { "error-missing-api-key": "Vui lòng nhập khóa API để thử giọng." }
					}
				},
				"kokoro-local": {
					"description": "Chuyển văn bản thành giọng nói cục bộ dùng Kokoro-82M.",
					"fields": { "field": { "model": {
						"label": "Chọn mô hình",
						"description": "Mô hình nhỏ tải nhanh hơn nhưng chất lượng thấp hơn chút."
					} } },
					"models": {
						"fp32-webgpu": { "description": "Mô hình độ chính xác cao dùng WebGPU - Khuyên dùng cho thiết bị hỗ trợ" },
						"fp32": { "description": "Độ chính xác đầy đủ (Full precision)" },
						"fp16": { "description": "Độ chính xác một nửa (Half precision)" },
						"q8": { "description": "Lượng tử hóa 8-bit" },
						"q4": { "description": "Lượng tử hóa 4-bit" },
						"q4f16": { "description": "4-bit với FP16" }
					},
					"playground": {
						"default-text": "Xin chào! Đây là bản thử nghiệm hệ thống giọng nói Kokoro.",
						"title": "Thử nghiệm giọng nói"
					},
					"title": "Kokoro TTS (Cục bộ)"
				},
				"microsoft-speech": {
					"fields": { "field": { "region": {
						"description": "Khu vực dịch vụ Speech",
						"label": "Khu vực"
					} } },
					"title": "Microsoft / Azure Giọng nói"
				},
				"index-tts-vllm": {
					"callout_indextts2_unavailable_title": "Hỗ trợ hạn chế",
					"callout_indextts2_unavailable": "IndexTTS2 hiện chưa hỗ trợ. Vui lòng dùng IndexTTS."
				},
				"minimax-speech": {
					"errors": { "provider-initialization-failed": "Không thể khởi tạo nhà cung cấp giọng nói MiniMax." },
					"fields": { "field": { "model": {
						"description": "Chọn mô hình TTS MiniMax để tạo giọng nói.",
						"label": "Mô hình",
						"placeholder": "Chọn một mô hình MiniMax..."
					} } },
					"playground": { "default-text": "Xin chào! Đây là bài kiểm tra tổng hợp giọng nói MiniMax." },
					"title": "MiniMax Giọng nói"
				},
				"openai-compatible": {
					"description": "Tương thích OpenAI",
					"title": "Tương thích OpenAI"
				},
				"n1n": { "description": "n1n.ai - Cung cấp API AI hiệu năng cao." },
				"volcengine": {
					"fields": { "field": { "appId": {
						"description": "App ID của dự án (lấy trong Console)",
						"label": "ID ứng dụng"
					} } },
					"title": "Động cơ Volcano"
				},
				"volcengine-coding-plan": {
					"description": "Kế hoạch Lập trình Volcengine",
					"models": {
						"ark-code-latest": { "description": "Sử dụng mô hình được chọn trong bảng điều khiển Coding Plan, bao gồm Auto; thay đổi sẽ có hiệu lực sau 3–5 phút." },
						"legacy": { "description": "Mô hình Coding Plan cũ đã được lên lịch ngừng hỗ trợ. Hãy chuyển sang mô hình hiện được hỗ trợ." }
					},
					"title": "Kế hoạch Lập trình Volcengine"
				},
				"byteplus-coding-plan": {
					"description": "Kế hoạch Lập trình BytePlus",
					"title": "Kế hoạch Lập trình BytePlus"
				},
				"browser-web-speech-api": {
					"description": "STT gốc trình duyệt (yêu cầu Chrome/Edge/Safari)",
					"title": "Web Giọng nói API"
				},
				"prompt-api": { "description": "Với Prompt API, bạn có thể gửi yêu cầu bằng ngôn ngữ tự nhiên đến mô hình cơ sở trong Chrome." },
				"official": {
					"title": "Nhà Cung Cấp Chính Thức",
					"description": "Nhà cung cấp AI chính thức bởi AIRI.",
					"speech-title": "Nhà cung cấp giọng nói chính thức",
					"speech-description": "Nhà cung cấp chuyển văn bản thành giọng nói chính thức của AIRI.",
					"speech-streaming-title": "Nhà Cung Cấp Giọng Nói Thời Gian Thực (Streaming) Chính Thức",
					"speech-streaming-description": "Nhà cung cấp text-to-speech độ trễ thấp chính thức bởi AIRI (WebSocket hai chiều).",
					"transcription-title": "Nhà Cung Cấp Phiên Âm Chính Thức",
					"transcription-description": "Nhà cung cấp speech-to-text chính thức bởi AIRI."
				},
				"transcriptions": { "playground": { "title": "Thử nghiệm chuyển văn bản" } },
				"aihubmix": { "description": "https://aihubmix.com (Giảm giá 10%)" }
			},
			"title": "Nhà cung cấp"
		},
		"connection": {
			"description": "Cấu hình kết nối máy chủ WebSocket",
			"title": "Kết nối",
			"websocket-url": {
				"description": "Địa chỉ đầy đủ máy chủ WebSocket (ví dụ ws://localhost:6121/ws)",
				"label": "Địa chỉ máy chủ WebSocket"
			},
			"server-hostname": {
				"label": "Expose On Network",
				"description": "Choose whether the AIRI gateway only listens on this device or can be reached from your local network."
			},
			"server-auth-token": {
				"label": "Auth Token",
				"description": "Security token required by remote clients that connect to this gateway. When left empty, AIRI generates a new token automatically.",
				"placeholder": "Tự động tạo"
			},
			"qr": {
				"title": "Connect from Stage Pocket",
				"description": "Scan this QR code from Stage Pocket to try all reachable local network addresses and save the first working one.",
				"refresh": "Làm mới",
				"image-alt": "AIRI server channel connection QR code",
				"candidates": "Các địa chỉ khả dụng",
				"token-hint": "The QR code includes the auth token so Stage Pocket can authenticate after connecting. Do not share it publicly.",
				"errors": {
					"title": "Không thể tạo mã QR",
					"unavailable": "Không thể chuẩn bị mã QR kết nối."
				}
			},
			"qr-scan": {
				"title": "Kết nối nhanh",
				"description": "Quét mã QR từ Tamagotchi để kết nối nhanh",
				"instructions": "Hướng camera vào mã QR kết nối AIRI.",
				"action": "Quét",
				"success": {
					"title": "Đã lưu địa chỉ kết nối",
					"description": "URL đã sử dụng: {url}"
				},
				"errors": {
					"title": "Quét mã QR thất bại",
					"failed": "Không thể quét hoặc kết nối bằng mã QR."
				}
			}
		},
		"system": {
			"color-scheme": {
				"description": "Đổi bảng màu sân khấu.",
				"title": "Bảng màu"
			},
			"developer": {
				"description": "Một số tùy chọn cho nhà phát triển.",
				"title": "Nhà phát triển"
			},
			"general": {
				"description": "Chế độ tối, ngôn ngữ, v.v.",
				"title": "Chung"
			},
			"permissions": {
				"description": "Xem trạng thái quyền hiện tại.",
				"title": "Quản lý quyền"
			},
			"description": "Tùy chỉnh thiết lập bối cảnh của bạn!",
			"sections": { "section": {
				"custom-color": {
					"fields": { "field": { "primary-color": {
						"label": "Màu chính",
						"rgb-on": { "title": "Tôi muốn nó động!" }
					} } },
					"title": "Bảng màu"
				},
				"developer": {
					"title": "Nhà phát triển",
					"sections": { "section": {
						"performance-visualizer": {
							"title": "Trực quan hiệu năng",
							"description": "Bật/Tắt lớp phủ FPS/tác vụ dài/bộ nhớ"
						},
						"markdown-stress": {
							"title": "Kiểm thử Markdown",
							"description": "Thử nghiệm phân tích Markdown với hội thoại lớn"
						},
						"use-magic-keys": {
							"title": "Công cụ useMagicKeys",
							"description": "Kiểm tra các phím tắt"
						},
						"audio-record": {
							"title": "Ghi âm",
							"description": "Kiểm tra các tính năng liên quan đến âm thanh"
						},
						"background-gradient-blending": {
							"title": "Hòa trộn màu nền",
							"description": "Kiểm tra hòa trộn và chủ đề"
						},
						"background-removal": {
							"title": "Xóa nền (Yêu cầu WebGPU)",
							"description": "Công cụ hỗ trợ xóa nền"
						},
						"chat": {
							"title": "Trò chuyện",
							"description": "Thử nghiệm hội thoại"
						},
						"gesture-circle": {
							"title": "Vòng tròn cử chỉ (Chỉ Desktop)",
							"description": "Kiểm tra nhận diện cử chỉ"
						},
						"image": {
							"title": "Hình ảnh",
							"description": "Xử lý hình ảnh"
						},
						"polaroid": {
							"title": "Phân cực",
							"description": "Công cụ chụp ảnh mô hình"
						},
						"context-flow": { "description": "Kiểm tra các bản cập nhật ngữ cảnh và sự kiện luồng chat" },
						"websocket-inspector": {
							"title": "Kiểm tra WebSocket",
							"description": "Theo dõi lưu lượng WebSocket thô"
						},
						"vibrant": {
							"title": "Trích xuất màu",
							"description": "Thử nghiệm trích xuất màu sắc"
						},
						"providers-transcription-realtime-aliyun-nls": {
							"title": "Công cụ chuyển đổi giọng nói thành văn bản theo thời gian thực của Aliyun",
							"description": "Truyền âm thanh micro tới Aliyun NLS và kiểm tra văn bản trực tiếp"
						},
						"performance-playground": {
							"title": "Khu thử nghiệm hiệu năng",
							"description": "Khu vực thử nghiệm biểu cảm VRM + đồng bộ môi TTS"
						}
					} }
				},
				"theme-presets": {
					"presets": {
						"default": {
							"colors": { "color-1": "Xanh AIRI" },
							"description": "Màu xanh lá mặc định do AIRI mang đến cho bạn!",
							"title": "Màu mặc định"
						},
						"morandi": {
							"colors": {
								"color-1": "Nâu xám",
								"color-2": "Be",
								"color-3": "Xám tro",
								"color-4": "Nâu nhạt",
								"color-5": "Ngà",
								"color-6": "Xám ô liu",
								"color-7": "Cát",
								"color-8": "Xám ấm"
							},
							"description": "Tông màu mềm mại lấy cảm hứng từ tranh của Giorgio Morandi",
							"title": "Màu Morandi"
						},
						"monet": {
							"colors": {
								"color-1": "Xanh da trời",
								"color-2": "Sương mù",
								"color-3": "Cát",
								"color-4": "Xanh rêu",
								"color-5": "Hoa súng",
								"color-6": "Lúa mì",
								"color-7": "Xanh đá phiến",
								"color-8": "Xanh xô thơm"
							},
							"description": "Bảng màu ấn tượng lấy cảm hứng từ tác phẩm của Claude Monet",
							"title": "Màu Monet"
						},
						"japanese": {
							"colors": {
								"color-1": "Nâu da cam",
								"color-2": "Nâu xám ấm",
								"color-3": "Nâu đất",
								"color-4": "Cà phê",
								"color-5": "Đồng",
								"color-6": "Vàng kim",
								"color-7": "Mù tạt",
								"color-8": "Hổ phách"
							},
							"description": "Bảng màu truyền thống Nhật Bản",
							"title": "Màu Nhật Bản"
						},
						"nordic": {
							"colors": {
								"color-1": "Xanh Bắc Âu",
								"color-2": "Băng",
								"color-3": "Vịnh hẹp",
								"color-4": "Thép",
								"color-5": "Sông băng",
								"color-6": "Đá phiến",
								"color-7": "Mây",
								"color-8": "Đá"
							},
							"description": "Phong cách màu tối giản vùng Quétdinavia",
							"title": "Màu Bắc Âu"
						},
						"chinese": {
							"colors": {
								"color-1": "Bình minh",
								"color-2": "Đỏ Trung Hoa",
								"color-3": "Nâu khói",
								"color-4": "Xanh tre",
								"color-5": "Tím đậm",
								"color-6": "Vàng hoàng kim",
								"color-7": "Xanh lam",
								"color-8": "Thổ hoàng"
							},
							"description": "Màu sắc truyền thống Trung Hoa, lấy cảm hứng từ dệt may, gốm sứ và hội họa cổ",
							"title": "Màu truyền thống Trung Hoa"
						}
					},
					"title": "Bộ Màu Có Sẵn"
				}
			} },
			"title": "Giao Diện"
		},
		"page": { "developers": { "open-devtools": {
			"title": "Mở Công cụ nhà phát triển",
			"button": "Mở"
		} } },
		"credits": { "buy": "Mua" },
		"scene": {
			"title": "Bối cảnh",
			"description": "Tùy chỉnh môi trường ảo cho nhân vật của bạn.",
			"beta_label": "Hệ thống bối cảnh",
			"beta_description": "Mỗi thẻ nhân vật chỉ định hình nền ưa thích từ thư viện này. Thiết lập tại đây sẽ đặt hình nền đó làm mặc định cho nhân vật đang hoạt động.",
			"background_image": {
				"title": "Hình nền nhân vật đang hoạt động",
				"no_background": "Nhân vật này chưa có hình nền đang hoạt động. Hãy tải lên ảnh vuông hoặc ảnh ngang để có kết quả tốt nhất.",
				"upload": "Tải lên thư viện",
				"change": "Đổi hình nền",
				"clear": "Xóa mặc định"
			},
			"gallery": {
				"title": "Thư viện bối cảnh",
				"empty": "Thư viện chưa có ảnh nào. Hãy tải một ảnh lên ở trên!",
				"set_as_global": "Đặt làm mặc định cho nhân vật",
				"delete": "Xóa khỏi thư viện",
				"global_badge": "Mặc định của nhân vật",
				"active_badge": "Bối cảnh hiện tại",
				"delete_confirm": "Bạn có chắc muốn xóa hình nền này không?"
			},
			"tip": {
				"label": "Mẹo!",
				"description": "Sử dụng ảnh vuông sẽ tận dụng chế độ cắt <b>cover</b> khi hiển thị dọc, tập trung vào trung tâm bối cảnh."
			}
		}
	},
	"sections": { "section": { "general": { "title": "Chung" } } },
	"theme": {
		"title": "Chủ Đề",
		"description": "Chuyển đổi chủ đề cơ bản của AIRI, Chế độ Sáng hoặc Chế độ Tối.\n"
	},
	"title": "Cài Đặt",
	"voices": "Giọng Nói",
	"vrm": {
		"change-model": {
			"from-file": "Tải từ Tệp",
			"from-file-select": "Chọn",
			"from-url": "Tải từ URL",
			"from-url-confirm": "Tải",
			"from-url-placeholder": "Nhập URL mô hình VRM",
			"title": "Thay Đổi Mô Hình"
		},
		"title": "Cài Đặt VRM",
		"scale-and-position": {
			"model-info-title": "Thông Tin Kích Thước Mô Hình",
			"model-info-x": "Chiều Rộng (X)",
			"model-info-y": "Chiều Dài (Y)",
			"model-info-z": "Chiều Cao (Z)",
			"tips": "Chỉnh sửa vị trí ban đầu của mô hình VRM.\nHệ trục tọa độ được hiển thị.\n",
			"scale": "Tỷ Lệ",
			"x": "Dịch X",
			"y": "Dịch Y",
			"z": "Dịch Z",
			"fov": "Góc Nhìn (độ)",
			"rotation-y": "Xoay Trục Y",
			"camera-distance": "Khoảng Cách Camera",
			"eye-tracking-mode": {
				"title": "Nhìn Vào",
				"options": { "option": {
					"mouse": "Chuột",
					"disabled": "Tắt"
				} }
			}
		},
		"switch-to-vrm": {
			"title": "Chuyển sang mô hình Live2D?",
			"change-to-vrm": "Nhấn vào đây để chuyển sang cài đặt Live2D avatar"
		},
		"theme-color-from-model": { "button-extract": { "title": "Trích Xuất" } },
		"skybox": {
			"skybox-intensity": "Cường Độ SkyBox",
			"skybox-specular-mix": "Độ Trộn Phản Chiếu"
		}
	},
	"spine": {
		"title": "Cài đặt Spine",
		"scale-and-position": {
			"title": "Tỷ lệ và vị trí",
			"scale": "Tỷ lệ"
		},
		"theme-color-from-model": {
			"title": "Trích xuất màu từ mô hình",
			"button-extract": { "title": "Trích xuất" }
		},
		"animation": {
			"title": "Hoạt ảnh",
			"idle-animation": "Hoạt ảnh nhàn rỗi (Idle)",
			"mix-duration": "Thời lượng trộn (giây)",
			"speed": "Tốc độ hoạt ảnh"
		},
		"appearance": { "title": "Diện mạo" },
		"variant": {
			"title": "Biến thể",
			"current-variant": "Biến thể đang hoạt động"
		},
		"skin": {
			"title": "Trang phục (Skin)",
			"current-skin": "Trang phục hiện tại"
		},
		"rendering": {
			"title": "Kết xuất",
			"max-fps": "FPS tối đa",
			"render-scale": "Tỷ lệ Render"
		},
		"fps": { "options": { "unlimited": "Không giới hạn" } }
	},
	"mmd": {
		"title": "Cài đặt MMD",
		"scale-and-position": {
			"title": "Tỷ lệ và vị trí",
			"scale": "Tỷ lệ",
			"rotation": "Xoay"
		},
		"theme-color-from-model": {
			"title": "Trích xuất màu từ mô hình",
			"button-extract": { "title": "Trích xuất" }
		},
		"physics": {
			"title": "Vật lý & Rig",
			"enabled": "Bật vật lý (tóc, váy, phụ kiện)",
			"ik": "Bật IK (động học ngược)",
			"grant": "Bật lan truyền xương phụ",
			"gravity": "Cường độ trọng lực"
		},
		"gaze": {
			"title": "Hướng nhìn",
			"tracking": "Nhìn vào",
			"options": {
				"cursor": "Chuột",
				"none": "Vô hiệu hóa"
			}
		},
		"animation": {
			"title": "Hoạt ảnh",
			"idle-motion": "Chuyển động chờ",
			"import-motion": "Nhập chuyển động (.vmd)",
			"play-once": "Xem trước hoạt ảnh",
			"remove": "Xóa chuyển động",
			"description": "Nhập các tệp chuyển động VMD, thiết lập một tệp làm chuyển động lặp nhàn rỗi, hoặc phát bất kỳ chuyển động nào dưới dạng cử chỉ một lần. Áp các cảm xúc vào chuyển động để phát các cử chỉ cùng với biểu cảm khuôn mặt."
		},
		"morphs": {
			"title": "Các biến thể hình dạng",
			"auto": "(Tự động)",
			"revert": "Khôi phục về tự động",
			"no-morphs": "Mô hình này không cung cấp morph nào.",
			"description": "Trình kết xuất tự động phát hiện các tên morph tiếng Nhật tiêu chuẩn (あいうえお, まばたき). Ghi đè một ô tại đây nếu mô hình của bạn sử dụng tên không tiêu chuẩn."
		},
		"materials": {
			"title": "Vật liệu",
			"no-materials": "Mô hình này không cung cấp vật liệu nào.",
			"description": "Điều chỉnh độ đục của các phần mô hình riêng lẻ (mặt, tóc, quần áo, phụ kiện). Đặt một phần thành 0 để ẩn phần đó đi."
		}
	},
	"tachie": {
		"title": "Cài đặt Tachie",
		"archive-description": "Mô hình Tachie sử dụng tệp lưu trữ .tachie.zip chứa các ảnh được đặt tên theo cảm xúc.",
		"scale-and-position": {
			"title": "Tỷ lệ và vị trí",
			"scale": "Tỷ lệ"
		},
		"theme-color-from-model": {
			"title": "Trích xuất màu từ mô hình",
			"button-extract": { "title": "Trích xuất" }
		},
		"rendering": {
			"title": "Kết xuất",
			"render-scale": "Tỷ lệ Render",
			"shadow": "Bóng đổ theo màu chủ đề"
		}
	},
	"websocket-secure-enabled": {
		"title": "Bật WebSocket bảo mật (WSS)",
		"description": "Bật WSS để hỗ trợ kết nối HTTPS cho thiết bị di động trong quá trình phát triển. Chứng chỉ tự ký sẽ được tạo tự động."
	},
	"wip": {
		"title": "Đang phát triển",
		"description": "Tính năng này hiện đang được hoàn thiện và chưa sẵn sàng công khai. Hãy chờ bản cập nhật trong tương lai nhé!"
	}
};
//#endregion
export { data as default };
